import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=4cd366ef&scoped=true&lang=pug&"
import script from "./NewsList.vue?vue&type=script&lang=ts&"
export * from "./NewsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd366ef",
  null
  
)

export default component.exports